import { format } from 'date-fns';

import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/itemized-sales',
};

export const getColumns = () => [
  {
    id: 'date',
    label: 'Date',
    customValue: (val) => format(new Date(val.date), 'dd MMMM yyyy'),
    align: 'center',
    nameForSort: 'date',
  },
  { id: 'barcode', label: 'Barcode', align: 'center', nameForSort: 'barcode' },
  { id: 'product', label: 'Product', align: 'center', nameForSort: 'product_name' },
  { id: 'vendor', label: 'Vendor', align: 'center', nameForSort: 'vendor_name' },
  { id: 'status', label: 'Status', align: 'center', nameForSort: 'status' },
  { id: 'retailPrice', label: 'Retail Price', align: 'center', disableSort: true },
  { id: 'region', label: 'Region', align: 'center', nameForSort: 'region' },
  { id: 'allowedMargin', label: 'Allowed Margin %', align: 'center', nameForSort: 'allowed_margin' },
  { id: 'costPrice', label: 'Cost Price', align: 'center', disableSort: true },
  { id: 'coinClaim', label: 'Coin Claim', align: 'center', disableSort: true },
  { id: 'quantity', label: 'Qty', align: 'center', nameForSort: 'quantity' },
  { id: 'turnover', label: 'Turnover', align: 'center', disableSort: true },
  { id: 'cost', label: 'Cost', align: 'center', nameForSort: 'cost' },
  { id: 'coinValue', label: 'Coin Value', align: 'center', disableSort: true },
  { id: 'grossIncome', label: 'Gross Revenue', align: 'center', disableSort: true },
  { id: 'totalRetail', label: 'Total Retail', align: 'center', disableSort: true },
];

export const getFilters = ({ dateRange, region, options }) => [
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'regions',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
];
